export default __webpack_public_path__ + "static/media/arrow-icon-blue.dda34795.svg";